/** `eur_exchange` de /search: unidades de la moneda de búsqueda por 1 EUR. */
export function amountToEur(amount: number, eurExchange?: number) {
  const rate = eurExchange && eurExchange > 0 ? eurExchange : 1
  return Math.round((amount / rate) * 100) / 100
}
